type NotifyApplicantByEmailProps = {
    notifyByEmail: boolean
    setNotifyByEmail: (notifyByEmail: boolean) => void
}
import { Checkbox } from "@/components/ui/checkbox"

// Controlled input component (you must pass the value and onChange props)
export default function NotifyApplicantByEmailCheckbox({
    notifyByEmail,
    setNotifyByEmail,
}: NotifyApplicantByEmailProps & {
    notifyByEmail: boolean
    setNotifyByEmail: (notifyByEmail: boolean) => void
}) {
    return (
        <div className="flex items-center gap-2 ml-auto">
            <Checkbox
                checked={notifyByEmail}
                onCheckedChange={(checked) =>
                    setNotifyByEmail(Boolean(checked.valueOf()))
                }
                name="notifyByEmail"
                aria-label="Should notify applicant by email"
            ></Checkbox>
            <label className="text-sm text-gray-500">
                Notify applicant by email?
            </label>
        </div>
    )
}
